import script from "./DashboardTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./DashboardTableLoader.vue?vue&type=style&index=0&id=42e09f37&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e09f37"]])

export default __exports__